const { appendFilter } = require('../../../queries');
const addPayeeGroupsQueries = require('../../../queries/configs/PayeeGroups');

module.exports = addPayeeGroupsQueries(function ({ baseUrl, payerId }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/payeegroups`,
    queriesFilter: appendFilter('payerId', payerId),
  })
});
